// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { enums } from "@msnews/social-utils";

export const CommentSuperAppStyles = (config: DesignSystem) => ({
    commentSuperAppContainer: {
        [`&.${enums.responsiveLevels.MobilePopup}`]: {
            "margin-left": "0",
            "margin-right": "0"
        }
    }
});